import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export function CustomButton({
  className,
  type,
  href,
  children,
  ...otherProps
}) {
  const customButton = cx(className, 'custom-button', {
    blue: type === 'blue',
  });

  return href ? (
    <Link className={customButton} to={href} {...otherProps}>
      {children}
    </Link>
  ) : (
    <button type="button" className={customButton} {...otherProps}>
      {children}
    </button>
  );
}

CustomButton.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  href: PropTypes.string,
};

CustomButton.defaultProps = {
  className: '',
  type: 'blue',
  href: '',
};

export default withComponentName(CustomButton);
